import {createSlice,PayloadAction } from '@reduxjs/toolkit';

import {RawWalletInfo } from '../../../../types/types';


type WalletInfoState = "LOADING" | "READY" | "ERROR";

interface WalletInfo  {
    info:RawWalletInfo,
    infoState:WalletInfoState,
    errorMessage:string
}

const initialState:WalletInfo = {

    info:{
        mnemonic:'',
        public_key:'',
        private_key:'',
    },
    infoState:'READY',
    errorMessage:""

}

const rawWalletInfo = createSlice({

    name: "rawWalletInfo",
    initialState,
    reducers: {

        startLoading(state) {
            state.infoState = 'LOADING';
        },

        hasError(state, action) {
            state.infoState = 'ERROR'
            state.errorMessage = action.payload;
        },

        addRawWalletInfo(state,action:PayloadAction<RawWalletInfo>){
            
            state.info = action.payload;
            state.infoState = 'READY';
            state.errorMessage = ''
        },

    },
    
});

export const {addRawWalletInfo} = rawWalletInfo.actions;
  
export default rawWalletInfo.reducer;